import moment from "moment";
import { deviceType, controlType } from "constant";

export const showEnergySaveIcon = (car) => {
    const isGasCtl = (ctl) => ctl === controlType.GCCM || ctl === "" || ctl == null || ctl == controlType.None;

    const timestamps = [
        car?.LastLocationUpdateInUtc,
        car?.LastRTInUtc,
        car?.LastWiFiInUtc
    ]
        .filter(Boolean)
        .map(d => moment.utc(d));

    if (!timestamps.length) {
        return false;
    }

    const latestTimestamp = moment.max(timestamps);
    const minutesSinceLastUpdate = moment().diff(latestTimestamp, "minutes");

    // Gas FT+ vehicles: show Energy Saver icon between 15 and 70 minutes
    if (isGasCtl(car?.CarControlType) &&
        car?.DevType === deviceType.FT2 &&
        minutesSinceLastUpdate >= 15 &&
        minutesSinceLastUpdate < 70) {
        return true;
    }

    return false;
}